class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});
document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});

document.querySelector('.search-close').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-search');
})

document.querySelector('.claire-btn').addEventListener('click', function(e) {
  document.querySelector('input#Search').value = '';
  document.querySelector('#predictive-search').style.display = 'none';
});



document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});

if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422)
          {
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          }else{          
            if(document.location.href.indexOf('/cart') > -1) {
              window.location.href = "/cart";
            }else{
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              }else{
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count>0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              }else{
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
    });
  });
}
if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
    });
  });
}
document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};


function recommendedProduct() {
  console.log('Recommended Product');
  const addButtons = document.querySelectorAll('.pv_add');

  addButtons.forEach((button) => {
    button.replaceWith(button.cloneNode(true));
  });

  const newButtons = document.querySelectorAll('.pv_add');
  newButtons.forEach((button) => {
    button.addEventListener(
      'click',
      function (e) {
        console.log('Recommended Product True---');
        e.preventDefault();

        const variantId = this.getAttribute('data-id');
        if (!variantId) {
          console.error('Variant ID not found!');
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            load_cart();
            document.querySelector('body').classList.add('open-drawer');
          })
          .catch((err) => {
            console.error('Add to cart failed:', err);
          });
      },
      { once: true }
    );
  });
}

recommendedProduct();

// =========================  product mobile add to cart 
function initMobileAddToCart() {
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".mb-add-tocart");
    if (!btn) return;
     e.preventDefault();
    const variantId = btn.dataset.id;
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(res => res.json())
      .then(() => {
        load_cart();  
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      })
      .catch(err => console.error("Add to cart error:", err));
  });
}
 initMobileAddToCart();

function updateFixedButtons() {
  const body = document.querySelector("body");
  const footer = document.querySelector(".section-footer");
  const snippetBtn = document.querySelector(".filter-button");

  if (!footer || !snippetBtn) return;

  const footerTop = footer.getBoundingClientRect().top + window.scrollY;
  const scrollY = window.scrollY;
  const windowHeight = window.innerHeight;

  if (scrollY + windowHeight >= footerTop) {
    body.classList.add("is-fixed");
  } else {
    body.classList.remove("is-fixed");
  }
}

updateFixedButtons();
window.addEventListener("scroll", updateFixedButtons);



// // JD Recently Viewed
// async function recentlyViewedProducts() {
//   const container = document.getElementById('recently-viewed-products-drawer');
//   if (!container) return;

//   const wrapper = container.querySelector('.pv_recently_viewed_section');
//   if (!wrapper) {
//     container.innerHTML = '<div class="pv_recently_viewed_section"></div>';
//   }

//   const handles = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
//   if (!handles.length) {
//     container.innerHTML = '<p class="empty-cart">No recently viewed products yet.</p>';
//     return;
//   }

//   const SECTION_ID = 'cart-recently-view';

//   try {
//     const sections = await Promise.all(
//       handles.map(async (handle) => {
//         try {
//           const res = await fetch(`/products/${handle}?sections=${SECTION_ID}`);
//           const json = await res.json();
//           return json[SECTION_ID];
//         } catch (err) {
//           console.error(`Failed to load ${handle}:`, err);
//           return `<div class="error">Failed to load ${handle}</div>`;
//         }
//       })
//     );

//     container.innerHTML = sections.join('');

//   } catch (error) {
//     console.error('Error loading recently viewed products:', error);
//     container.innerHTML = '<p class="error">Failed to load recently viewed products.</p>';
//   }
// }


// // JD Track Recently Viewed
// function trackRecentlyViewedWhenReady() {
//   const checkInterval = setInterval(() => {
//     const productSection = document.querySelector('.section-product[product-id]');
//     if (productSection) {
//       clearInterval(checkInterval);
//       trackRecentlyViewed();
//     }
//   }, 100);
// }
// function trackRecentlyViewed() {
//   const productSection = document.querySelector('.section-product[product-id]');
//   if (!productSection) return;

//   const productHandle = window.location.pathname.split('/products/')[1]?.replace(/\/$/, '');
//   if (!productHandle) return;

//   let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
//   recentlyViewed = recentlyViewed.filter(h => h !== productHandle);
//   recentlyViewed.unshift(productHandle);
//   recentlyViewed = recentlyViewed.slice(0, 5);
//   localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
//   recentlyViewedProducts();
// }

// document.addEventListener("DOMContentLoaded", trackRecentlyViewed);
// window.addEventListener("pageshow", () => {
//   trackRecentlyViewedWhenReady();
// });


// ---------- TRACK RECENTLY VIEWED (PDP) ----------
function trackRecentlyViewed() {
  const productSection = document.querySelector('.section-product[product-id]');
  if (!productSection) return;

  const productHandle = window.location.pathname.split('/products/')[1]?.replace(/\/$/, '');
  if (!productHandle) return;

  let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

  recentlyViewed = recentlyViewed.filter(h => h !== productHandle);
  recentlyViewed.unshift(productHandle);
  recentlyViewed = recentlyViewed.slice(0, 5);

  localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));  
}


document.addEventListener("DOMContentLoaded", trackRecentlyViewed);
window.addEventListener("pageshow", (e) => {
  if (e.persisted) {
    setTimeout(trackRecentlyViewed, 50);
  }
});


// ---------- LOAD RECENTLY VIEWED PRODUCTS (HOME PAGE) ----------
async function recentlyViewedProducts() {
  const container = document.getElementById('recently-viewed-products-drawer');
  if (!container) return;

  const handles = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

  if (!handles.length) {
    container.innerHTML = '<p class="empty-cart">No recently viewed products yet.</p>';
    return;
  }

  const SECTION_ID = 'cart-recently-view';
  const sections = await Promise.all(
    handles.map(async (handle) => {
      try {
        const res = await fetch(`/products/${handle}?sections=${SECTION_ID}`);
        const json = await res.json();
        return json[SECTION_ID];
      } catch {
        return `<div class="error">Failed to load ${handle}</div>`;
      }
    })
  );

  container.innerHTML = sections.join('');
  if (typeof recommendedProduct === "function") {
    recommendedProduct();
  }
}

document.addEventListener("DOMContentLoaded", recentlyViewedProducts);
window.addEventListener("pageshow", (e) => {
  if (e.persisted) {
    setTimeout(() => {
      recentlyViewedProducts();
    }, 50);
  }
});






// JD Quantity
function quantity() {
  const qtyWrappers = document.querySelectorAll('.quantity-selector');

  qtyWrappers.forEach((wrapper) => {
    const qtyInput = wrapper.querySelector('.quantity-input');
    const plusBtn = wrapper.querySelector('.qty-btn.plus');
    const minusBtn = wrapper.querySelector('.qty-btn.minus');

    if (!qtyInput || !plusBtn || !minusBtn) return;

    // Function to toggle disabled class
    const toggleDisabledClass = () => {
      if (parseInt(qtyInput.value) <= 1) {
        minusBtn.classList.add("disabled");
      } else {
        minusBtn.classList.remove("disabled");
      }
    };

    // Initial state check
    toggleDisabledClass();

    plusBtn.addEventListener('click', function () {
      let currentVal = parseInt(qtyInput.value) || 1;
      qtyInput.value = currentVal + 1;

      toggleDisabledClass();
      qtyInput.dispatchEvent(new Event('change'));
    });

    minusBtn.addEventListener('click', function () {
      let currentVal = parseInt(qtyInput.value) || 1;

      if (currentVal > 1) {
        qtyInput.value = currentVal - 1;
      }

      toggleDisabledClass();
      qtyInput.dispatchEvent(new Event('change'));
    });
  });
}

document.addEventListener('DOMContentLoaded', quantity);

function productcarousel(){
  var productslider=[];
  document.querySelectorAll('.product-carousel').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.carousel-rowouter');
    let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let swiperObject={
      loop:eval(Element.dataset.loop),
      slidesPerView: "auto",
      spaceBetween: 15,
      speed: 800,
      effect: 'slide',
      navigation: {
        nextEl:nextbutton,
        prevEl:prevbutton,
      },
    };    
    productslider[productid]=new Swiper(Element,swiperObject);
  });
}
productcarousel();


if (!customElements.get('quick-complementary-products')) {
  customElements.define('quick-complementary-products',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        this.initialized = false;
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const initFn = this.init.bind(this);
        if ('requestIdleCallback' in window) {
          requestIdleCallback(initFn, { timeout: 1500 });
        } else if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries, obs) => {
            if (entries[0].isIntersecting) {
              obs.disconnect();
              initFn();
            }
          }, { rootMargin: '400px' });
          observer.observe(this);
        } else {
          setTimeout(initFn, 1000);
        }
      }

      init() {
        const existingProducts = this.querySelectorAll('.ra_product');
        if (existingProducts.length > 0) {
          console.log(' Complementary products already loaded:', existingProducts.length);
          if (typeof recommendedProduct === 'function') recommendedProduct();
          return;
        }

        const url = this.dataset.url;
        if (!url) return;

        this.classList.add('is-loading');
        fetch(url, { cache: 'no-cache' })
          .then(r => r.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const sectionHTML = doc.querySelector('.shopify-section');
            if (!sectionHTML) return;

            const recommendations = sectionHTML.querySelector('quick-complementary-products');
            if (!recommendations) return;

            const raProducts = recommendations.querySelectorAll('.ra_product');

            if (raProducts.length > 0) {
              this.style.opacity = '0';
              requestAnimationFrame(() => {
                this.innerHTML = recommendations.innerHTML;
                this.style.transition = 'opacity 0.3s ease';
                this.style.opacity = '1';
              });
              console.log('Loaded complementary products:', raProducts.length);
            } else {
              this.closest('.product__block')?.remove();
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }

            // if (typeof recommendedProduct === 'function') recommendedProduct();
            this.classList.remove('is-loading');
            setTimeout(() => {
            recommendedProduct();  
            }, 100);
            
          })
          .catch(err => {
            console.error('Error loading recommendations:', err);
            this.classList.remove('is-loading');
          });
      }
    }
  );
}


// ----------------------------------------------------------------------------


function ShippingCalculator() {
  const btn = document.querySelector(".get-rates");
  if (!btn) return;

  console.log("Shipping Calculator Initialized");

  const country = document.getElementById("address_country");
  const province = document.getElementById("address_province");
  const provinceContainer = document.getElementById("address_province_container");
  const zip = document.getElementById("address_zip");
  const responseBox = document.getElementById("wrapper-response");

  /* INIT COUNTRY → STATE (OFFICIAL) */
  if (window.Shopify && Shopify.CountryProvinceSelector) {
    new Shopify.CountryProvinceSelector(
      "address_country",
      "address_province",
      { hideElement: "address_province_container" }
    );
  }

  /* MAIN CLICK */
  btn.addEventListener("click", async function () {
    const c = country.value;
    const p = province.value;
    const z = zip.value.trim();

    /* VALIDATION */
    if (provinceContainer.style.display !== "none" && !p) {
      responseBox.innerHTML = "<p>Please select a state.</p>";
      return;
    }

    if (!z) {
      responseBox.innerHTML = "<p>Please enter ZIP / Postal code.</p>";
      return;
    }

    responseBox.innerHTML = "<p>Calculating shipping…</p>";

    const params = new URLSearchParams({
      "shipping_address[country]": c,
      "shipping_address[province]": p,
      "shipping_address[zip]": z
    }).toString();

    /* PREPARE */

    let prepareResponse;

    try {
      prepareResponse = await fetch(
        `${Shopify.routes.root}cart/prepare_shipping_rates.json?${params}`,
        { method: "POST" }
      );

      if (!prepareResponse.ok) {
        throw new Error("INVALID_PROVINCE_ZIP");
      }

    } catch (e) {
      responseBox.innerHTML =
        "<p>ZIP code do not match. Please check and try again.</p>";
      return;
    }


    // await fetch(`${Shopify.routes.root}cart/prepare_shipping_rates.json?${params}`, {
    //   method: "POST"
    // });

    /* POLL */
    const start = Date.now();
    const timeout = 9000;

    async function poll() {
      const res = await fetch(
        `${Shopify.routes.root}cart/async_shipping_rates.json?${params}`
      );
      const data = await res.json();

      if (data?.shipping_rates) {
        let html = `<p><strong>${data.shipping_rates.length} rate(s):</strong></p><ul style="margin-left:0;">`;

        data.shipping_rates.forEach(r => {
          // html += `<li>${r.name} – ${r.price}</li>`;
          let etaText = "";
          if (r.delivery_range && r.delivery_range.length === 2) {
            const startDate = new Date(r.delivery_range[0]);
            const endDate = new Date(r.delivery_range[1]);

            etaText = ` (Delivers between ${startDate.toDateString()} – ${endDate.toDateString()})`;
          }
          else if (r.delivery_date) {
            const d = new Date(r.delivery_date);
            etaText = ` (Delivers by ${d.toDateString()})`;
          }
          html += `<li>${r.name} – ${r.price}${etaText}</li>`;
        });

        html += `</ul>`;
        responseBox.innerHTML = html;
        return;
      }

      if (Date.now() - start > timeout) {
        responseBox.innerHTML = "<p>Timeout loading shipping rates.</p>";
        return;
      }

      setTimeout(poll, 600);
    }

    poll();
  });
}


/*function ShippingCalculator() {
  const btn = document.querySelector(".get-rates");
  if (!btn) return; // Drawer not open yet

  console.log("Shipping Calculator Initialized");

  const country = document.getElementById("address_country");
  const province = document.getElementById("address_province");
  const provinceContainer = document.getElementById("address_province_container");
  const zip = document.getElementById("address_zip");
  const responseBox = document.getElementById("wrapper-response");

  // COUNTRY → PROVINCE
  if (country && Shopify && Shopify.countries) {
    country.addEventListener("change", function () {
      const provs = Shopify.countries[this.value];
      province.innerHTML = "";

      if (provs && provs.length > 0) {
        provinceContainer.style.display = "block";
        provs.forEach(p => {
          const opt = document.createElement("option");
          opt.value = p[0];
          opt.textContent = p[1];
          province.appendChild(opt);
        });
      } else {
        provinceContainer.style.display = "none";
      }
    });
  }

  // MAIN CLICK EVENT
  btn.addEventListener("click", async function () {

    const c = country.value;
    const p = province.value || "";
    const z = zip.value.trim();

    if (!z) {
      responseBox.innerHTML = "<p>Please enter a ZIP / postal code.</p>";
      return;
    }

    responseBox.innerHTML = "<p>Calculating shipping…</p>";

    /* PREPARE 
    const prepareURL = `${Shopify.routes.root}cart/prepare_shipping_rates.json?shipping_address[country]=${encodeURIComponent(c)}&shipping_address[province]=${encodeURIComponent(p)}&shipping_address[zip]=${encodeURIComponent(z)}`;
    await fetch(prepareURL, { method: "POST" });

    /* POLL 
    const pollURL = `${Shopify.routes.root}cart/async_shipping_rates.json?shipping_address[country]=${encodeURIComponent(c)}&shipping_address[province]=${encodeURIComponent(p)}&shipping_address[zip]=${encodeURIComponent(z)}`;
    
    const start = Date.now();
    const timeout = 9000;

    async function poll() {
      const res = await fetch(pollURL);
      const data = await res.json();

      if (data && data.shipping_rates) {

        let html = `<p><strong>${data.shipping_rates.length} rate(s):</strong></p><ul style="margin-left:0;">`;

        data.shipping_rates.forEach(r => {

          let etaText = "";
          if (r.delivery_range && r.delivery_range.length === 2) {
            const startDate = new Date(r.delivery_range[0]);
            const endDate = new Date(r.delivery_range[1]);

            etaText = ` (Delivers between ${startDate.toDateString()} – ${endDate.toDateString()})`;
          }
          else if (r.delivery_date) {
            const d = new Date(r.delivery_date);
            etaText = ` (Delivers by ${d.toDateString()})`;
          }
          html += `<li>${r.name} – ${r.price}${etaText}</li>`;
        });
        html += `</ul>`;
        responseBox.innerHTML = html;
        return;
      }
      if (Date.now() - start > timeout) {
        responseBox.innerHTML = "<p>Timeout loading shipping rates.</p>";
        return;
      }
      setTimeout(poll, 600);
    }
    poll();
  });
}*/

function applyHeights() {
    const quickItems = document.querySelectorAll('.wrap-quick-btns');
    const soldOutItems = document.querySelectorAll('.sold-out-wrap');

    let maxHeight = 0;

    // Reset quick heights before measuring
    quickItems.forEach(item => {
        item.style.height = 'auto';
    });

    // Get tallest wrap-quick-btns height
    quickItems.forEach(item => {
        const h = item.offsetHeight;
        if (h > maxHeight) maxHeight = h;
    });

    // Set same height for all wrap-quick-btns
    quickItems.forEach(item => {
        item.style.height = maxHeight + 'px';
    });

    // Set sold-out-wrap height = tallest wrap-quick-btns height
    soldOutItems.forEach(item => {
        item.style.height = maxHeight + 'px';
    });
}

window.addEventListener('load', applyHeights);
window.addEventListener('resize', applyHeights);
